import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { PlatformSource } from '@/api/types/common.types';
import { useMobileDetect } from '@/hooks/useMobileDetect';

export function usePlatformSource() {
  const { isWebView } = useBridgeState();
  const { isDesktop } = useMobileDetect();

  switch (true) {
    case isWebView:
      return PlatformSource.App;
    case isDesktop:
      return PlatformSource.Desktop;
    default:
      return PlatformSource.Mobile;
  }
}
